import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_CORGI_SSR_TIMINGS_RESPONSE_HEADER = createFcmConfig('corgi_ssr_timings_response_header', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
